import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
// import { GoogleOAuthProvider } from '@react-oauth/google';

// Arranca la capa de analytics (EC-3811). Import por efecto secundario, antes de
// renderizar. No inicializa nada en /sso-bridge ni /reset-password, y todo su
// init está en try/catch: nunca puede tumbar la app.
import './analytics/bootstrap';
import { analytics } from './analytics';
import { AnalyticsSessionBridge } from './analytics/react/AnalyticsSessionBridge';

// Único punto por el que pasan todos los fetches de server state (por convención
// del repo, ver CLAUDE.md). Se usa para detectar el vencimiento de sesión sin
// tocar utilities/axios.interceptors.ts, que está en zona protegida.
//
// El 401 del interceptor hace window.location.replace de inmediato, así que el
// evento sale con sendBeacon para sobrevivir al unload. No se envía el error ni
// la URL: los mensajes de ec-be pueden nombrar al paciente y la URL lleva el :id.
const onSessionExpired = (error) => {
  if (error?.response?.status !== 401) return;
  analytics.track('session_expired', { source: 'interceptor_401' }, { flush: true });
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
  queryCache: new QueryCache({ onError: onSessionExpired }),
  mutationCache: new MutationCache({ onError: onSessionExpired }),
});

const storedDarkMode = localStorage.getItem("appDarkMode");
const legacyDarkMode = localStorage.getItem("operativeDarkMode");
const shouldUseDark =
  storedDarkMode !== null
    ? storedDarkMode === "true"
    : legacyDarkMode === "true";

if (shouldUseDark) {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}

// eslint-disable-next-line no-undef
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<div>Cargando...</div>}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter future={{v7_relativeSplatPath: true}}>
            {/* Hoja: no renderiza nada. Va DENTRO del router (necesita useLocation)
                y del Provider (lee la sesión), pero FUERA de <App/>: App.js:28
                llama createTheme() sin memo, así que un useLocation ahí
                reconstruiría el theme MUI en cada navegación. */}
            <AnalyticsSessionBridge />
            <App />
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
  </Suspense>
);

